export default __webpack_public_path__ + "static/media/thumbnail.35a5e758.png";